import React, {useEffect, useState} from "react";
import {PaymentTableResponseData} from "../../../types/client";
import {clientPaymentTableAPI} from "../../../services/client";
import {Column} from "../../common/table/TableSection";
import styles from "../../admin/document/AdminDocumentTable.module.css";
import Table from "../../common/table/Table";

interface ExtendedColumn<T> extends Column<T> {
    render?: (value: any, row: T, index: number) => React.ReactNode;
}

const ClientBillingTable = ({onSelectedDataChange}: {
    onSelectedDataChange?: (data: PaymentTableResponseData[]) => void
}) => {
    const [data, setData] = useState<PaymentTableResponseData[]>([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());

    useEffect(() => {
        const selectedData = data.filter(row => selectedRows.has(row.paymentId));
        onSelectedDataChange?.(selectedData);
    }, [selectedRows, data]);

    const handleSelectAll = (checked: boolean) => {
        if (checked) {
            const allIds = data.map(row => row.paymentId);
            setSelectedRows(new Set(allIds));
        } else {
            setSelectedRows(new Set());
        }
    };

    const handleSelectRow = (paymentId: number, checked: boolean) => {
        const newSelected = new Set(selectedRows);
        if (checked) {
            newSelected.add(paymentId);
        } else {
            newSelected.delete(paymentId);
        }
        setSelectedRows(newSelected);
    };

    //컬럼
    const columns: ExtendedColumn<PaymentTableResponseData>[] = [
        {
            key: 'checkbox',
            header: (
                <input
                    type="checkbox"
                    checked={data.length > 0 && selectedRows.size === data.length}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    className={styles.checkbox}
                />
            ),
            width: '40px',
            render: (_, row) => (
                <input
                    type="checkbox"
                    checked={selectedRows.has(row.paymentId)}
                    onChange={(e) => handleSelectRow(row.paymentId, e.target.checked)}
                    onClick={(e) => e.stopPropagation()}
                    className={styles.checkbox}
                />
            )
        },
        {
            key: 'payFor',
            header: '서비스 이용기간',
            width: '20%',
            render: (value) => {
                const date = new Date(value);
                return `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}`;
            }
        },
        {
            key: 'orderName',
            header: '주문명',
            width: '20%'
        },
        {
            key: 'paidAt',
            header: '결제일자',
            width: '20%'
        },
        {
            key: 'paymentType',
            header: '결제 방법',
            width: '20%'
        },
        {
            key: 'amount',
            header: '결제 금액',
            width: '20%',
            render: (value) => {
                return value.toLocaleString() + '원'
            }
        }
    ]

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await clientPaymentTableAPI({page: page - 1});
            setData(response.content);
            setTotalPages(Math.ceil(response.total) / 7);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, [page]);

    return (
        <div>
            <Table
                columns={columns}
                data={data}
                loading={loading}
                size="medium"
                showPagination={true}
                page={page}
                pageSize={7}
                totalItems={totalPages * 7}
                onPageChange={setPage}
            />
        </div>
    )
}
export default ClientBillingTable;